const defaultTheme = {
  palette: {
    common: {black: '#000', white: '#fff'},
    background: {paper: '#fff', default: '#fafafa'},
    primary: {
      light: '#78f39d',
      main: '#20a849',
      dark: '#038129',
      contrastText: '#fff',
    },
    secondary: {
      light: '#a8a8a8',
      main: '#666666',
      dark: '#212121',
      contrastText: '#fff',
    },
    error: {
      light: '#e57373',
      main: '#f44336',
      dark: '#d32f2f',
      contrastText: '#fff',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.54)',
      disabled: 'rgba(0, 0, 0, 0.28)',
    },
  },
  success: {
    main: '#34C759',
    light: '#EAF9E0',
    dark: '#1F7A3C',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#FF952A',
    light: '#FFF7EE',
    dark: '#FF952A',
    contrastText: '#ffffff',
  },
  info: {
    main: '#1791DD',
    light: '#EEF7FD',
    dark: '#5CB1E7',
    contrastText: '#ffffff',
  },
  boxShadow: {
    primary: 'rgba(0, 0, 0, 0.10)',
    hint: 'rgba(0, 0, 0, 0.15)',
  },
  borderColor: {
    main: '#cccccc',
    light: '#e9e9e9',
    dark: '#a8a8a8',
  },
  rippleColor: '#bfe5fe',
  themeGrey: {
    high_emphasis_grey: '#212121',
    medium_emphasis_grey: '#666666',
    disabled_grey: '#a8a8a8',
    border_grey: '#cccccc',
    input_disabled: '#e9e9e9',
    input_active: '#e1e1e1',
  },
}

export default defaultTheme
